import { InvestorInvitationStatus } from '@dealstack/shared/lib/generated';
import type { AccountActivityState } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/Investors/InvestorDetailsV2/components/AccountActivityCard/accountActivity.types.ts';

export const resolveAccountActivityState = (
	status?: InvestorInvitationStatus
): AccountActivityState => {
	switch (status) {
		case InvestorInvitationStatus.ACTIVE:
			return 'active';
		case InvestorInvitationStatus.INVITED:
			return 'awaiting-login';
		default:
			return 'not-invited';
	}
};
